export enum FieldType {
  Author = "author",
  CategoryRelations = "category-relations",
  CategoriesSelect = "categories-select",
  CategoriesTable = "categories-table",
  Checkbox = "checkbox",
  ColorPicker = "color-picker",
  DatePicker = "date-picker",
  DictionaryValuesSelect = "dictionary-values-select",
  DifficultySelect = "difficulty-select",
  Domains = "domains",
  Editor = "editor",
  FileDownload = "file-download",
  FilesList = "files-list",
  FilesPicker = "files-picker",
  Image = "image",
  ImageCropper = "image-cropper",
  Input = "input",
  BigInput = "big-input",
  LanguageSelect = "language-select",
  Languages = "languages",
  MainLanguageSelect = "main-language-select",
  Multi = "multi",
  NumberInput = "number-input",
  ParentCategorySelect = "parent-category-select",
  PermissionsTable = "permissions-table",
  ProjectsSelect = "projects-select",
  ProjectUsersTable = "project-users-table",
  ProjectLanguagesSelect = "project-languages-select",
  RadioButton = "radio-button",
  RobotsSelect = "robots-select",
  RolesSelect = "roles-select",
  RolesMultiSelect = "roles-multi-select",
  Select = "select",
  SlugInput = "slug-input",
  SeoTagsetSubject = "subject",
  SlideVariant = "slide-variant",
  SocialMedia = "social-media",
  TagsSelect = "tags-select",
  UserFullName = "user-full-name",
  UsersProjectSelect = "users-project-select",
  UsersProjects = "users-projects",
  UsersSelect = "users-select",
  UserStatus = "user-status",
  TextArea = "text-area",
  Token = "token",
  Switch = "switch",
}

type BasicField = {
  id: string;
  label: string;
  caption?: string;
  placeholder?: string;
  autocomplete?: string;
  info?: string;
  span?: number;
  skip?: number;
  dataType?: string;
  typeName?: string;
  type: FieldType[keyof FieldType];
  mask?: string;
  maskChar?: string;
  endEnhancer?: string;
  startEnhancer?: string;
  readonly?: boolean;
  maxLength?: number;
  imageRequirements?: {
    aspect?: number;
    rounded?: boolean;
    allowVectors?: boolean;
  };
  dictionarySystemName?: string;
  maxSize?: number;
};

export type Field = {
  show: { visible: boolean; accessor?: string | string[]; span?: number };
  create: { visible: boolean; required?: boolean };
  update: { visible: boolean; required?: boolean };
} & BasicField;

type BasicFieldsGroup = {
  id: string;
  label: string;
};

export type FieldsGroup = {
  fields: Field[];
  accessor?: string;
} & BasicFieldsGroup;
